import React from "react";
import { createRoot } from "react-dom/client";
import ColorPicker from "./ColorPicker";

function ColorPickerComponent(props) {
    const { titleColorPicker } = props.attributes;

    const handleColorChange = (color) => {
        console.log("Выбранный цвет:", color);
    };

    return (
        <div>
            {/* <h1>{titleColorPicker}</h1> */}
            <ColorPicker
                onColorChange={handleColorChange}
                attributes={props.attributes}
            />
        </div>
    );
}

export default ColorPickerComponent;

if (document.getElementById("color-picker")) {
    const colorPickerElement = document.getElementById("color-picker");
    const root = createRoot(colorPickerElement);
    const attributes = {
        titleSave: colorPickerElement.getAttribute("titleSave"),
        titleClear: colorPickerElement.getAttribute("titleClear"),
        titleCopied: colorPickerElement.getAttribute("titleCopied"),
        titleColorPicker: colorPickerElement.getAttribute("titleColorPicker"),
    };
    root.render(<ColorPickerComponent attributes={attributes} />);
}
